<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left
              @click="changeTab">
              email
            </v-icon>
            <span class="title">Data Remun</span>
          </v-card-title>
          <v-tabs
            v-model="tabsurat"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              List Remun
              <v-icon large>playlist_add_check</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew" v-if="false">
              Buat Baru
              <v-icon large>playlist_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabsurat">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="4">
                        <v-select
                          :items="listperiode"
                          name="statussurat"
                          v-model="filter.status"
                          label="Periode"
                          @change="getSurat">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.changest">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">
                                  No
                                </th>
                                <th class="text-left">
                                  NIP
                                </th>
                                <th class="text-left">
                                  Nama
                                </th>
                                <th class="text-left">
                                  Remun P1
                                </th>
                                <th class="text-left">
                                  Remun P2
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>1</td>
                                <td>197104191997021001</td>
                                <td>I KETUT GEDE SUDIARTHA</td>
                                <td>15.005.100</td>
                                <td>38.115.000</td>
                              </tr>
                              <tr>
                                <td>2</td>
                                <td>199108312022031007</td>
                                <td>GDE BRAHUPADHYA SUBIKSA</td>
                                <td>12.135.000</td>
                                <td>36.125.100</td>
                              </tr>
                              <tr>
                                <td>3</td>
                                <td>196110201988031001</td>
                                <td>I GEDE KETUT SRI BUDARSA</td>
                                <td>14.505.100</td>
                                <td>37.211.000</td>
                              </tr>
                              <tr>
                                <td>4</td>
                                <td>196603201991031002</td>
                                <td>I MADE SAJAYASA</td>
                                <td>16.100.100</td>
                                <td>38.515.000</td>
                              </tr>
                              <tr>
                                <td>5</td>
                                <td>199009012019031012</td>
                                <td>Agus Adi Putrawan</td>
                                <td>14.205.100</td>
                                <td>36.215.000</td>
                              </tr>
                              <tr>
                                <td>6</td>
                                <td>199011052019031009</td>
                                <td>I Komang Wiratama</td>
                                <td>13.815.000</td>
                                <td>35.810.000</td>
                              </tr>
                              <tr>
                                <td>7</td>
                                <td>197111051999031002</td>
                                <td>I Gusti Ngurah Bagus Caturbawa</td>
                                <td>18.105.100</td>
                                <td>40.125.000</td>
                              </tr>
                              <tr>
                                <td>8</td>
                                <td>199004042019031017</td>
                                <td>I Made Riyan Adi Nugroho</td>
                                <td>14.006.520</td>
                                <td>37.350.720</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <v-data-table
                          v-if="false"
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.tanggal_surat`]="{ item }">
                            {{ item.tanggal_surat | dateToAge }}
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              :to="{ name: 'SuratDetailDosen', params: { kodesurat: item.kd_skm }}"
                              small
                              icon>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                        <div class="text-right mt-5">
                          <alertsp :alertdata="alertdata"></alertsp>
                          <v-btn
                            large
                            :loading="loading.addsurat"
                            :disabled="loading.addsurat"
                            color="success"
                            class="mt-2"
                            @click="postingSakku()">
                            Posting SAKKU
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <alertsp :alertdata="alertdata"></alertsp>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formaddsurat"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" sm="8" md="6">
                          <v-row>
                            <v-col cols="12">
                              <v-autocomplete
                                name="jenissurat"
                                v-model="addsurat.jenis_surat"
                                :items="listjenissurat"
                                item-value="id_js"
                                item-text="nama_js"
                                return-object
                                @change="updateJenisSurat"
                                label="Jenis Surat">
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addsurat.nik_surat"
                                :counter="16"
                                :rules="[rules.required, rules.nik]"
                                label="NIK"
                                name="nik"
                                required
                                @blur="checkNik"
                                :hint="datanik.nama"
                                persistent-hint>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-textarea
                                v-model="addsurat.deskripsi_surat"
                                auto-grow
                                label="Deskripsi Surat"
                                :rules="[rules.required]"
                                rows="1"
                                :hint="'Lengkapi deskripsi sesuai dengan keperluan'"
                                persistent-hint>
                              </v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-textarea
                                v-model="addsurat.peruntukan_surat"
                                auto-grow
                                label="Keperluan Surat"
                                :rules="[rules.required]"
                                rows="1"
                                :hint="'Tuliskan tujuan pembuatan surat'"
                                persistent-hint>
                              </v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <div class="text-center" v-if="loading.addsurat">
                                <v-progress-circular
                                  :width="3"
                                  color="red"
                                  indeterminate>
                                </v-progress-circular>
                              </div>
                              <v-btn
                                v-if="!loading.addsurat"
                                large
                                block
                                :disabled="!formadd.valid || !datanik.valid"
                                color="success"
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'SuratDosen',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      changest: false,
      addsurat: false,
      checknik: false,
      printpengantar: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    modulklian: process.env.VUE_APP_MOD_KLIAN,
    liststatus: ['permohonan', 'siap', 'tolak', 'semua'],
    listperiode: ['20231', '20232', '20241', '20242'],
    filter: {
      search: '',
      status: '',
    },
    headers: [
      { text: 'Refernsi', value: 'kd_skm' },
      { text: 'Nomor', value: 'no_skm' },
      { text: 'NIK', value: 'user_skm' },
      { text: 'Nama', value: 'p_nama' },
      { text: 'Jenis', value: 'nama_js' },
      { text: 'Tanggal', value: 'tgl_skm' },
      { text: 'Status', value: 'status_skm' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    listjenissurat: [],
    addsurat: {
      nik_surat: '',
      kode_surat: '',
      jenis_surat: '',
      jenis_surat_l: '',
      deskripsi_surat: '',
      peruntukan_surat: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
    },
    tabsurat: null,
    datanik: {
      valid: false,
      nama: 'nik tidak ditemukan',
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'userbanjar',
    ]),
  },
  mounted() {
    if (this.$route.query.type && this.$route.query.type !== '') {
      this.filter.status = this.$route.query.type;
    }
    if (this.$route.query.tab && this.$route.query.tab !== '') {
      this.changeTab(this.$route.query.tab);
    }
    if (this.$route.query.nik && this.$route.query.nik !== '') {
      this.addsurat.nik_surat = this.$route.query.nik;
      this.checkNik();
    }
    this.getSurat();
    this.getJenisSurat();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    postingSakku() {
      this.loading.addsurat = true;
      this.alertdata.show = false;
      setTimeout(() => {
        this.loading.addsurat = false;
        this.alertdata.show = true;
        this.alertdata.type = 'success';
        this.alertdata.text = 'Posting data ke SAKKU berhasil!';
      }, 8000);
    },
    printPengantar(kodeSurat, nikSurat) {
      if (this.tokenscr && kodeSurat && nikSurat) {
        this.loading.printpengantar = true;
        this.axios
          .get(
            this.api + '/api/surat/pengantar/' + kodeSurat + '/' + nikSurat,
            {
              params: {},
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
              responseType: 'blob',
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', kodeSurat + '-PENGANTAR.doc');
              document.body.appendChild(link);
              link.click();
            }
            this.loading.printpengantar = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.printpengantar = false;
          });
      }
    },
    changeTab(tabdata) {
      this.tabsurat = tabdata;
    },
    updateJenisSurat(data) {
      this.addsurat.kode_surat = data.kode_js;
      this.addsurat.jenis_surat = data.id_js;
      this.addsurat.jenis_surat_l = data.nama_js;
      this.addsurat.deskripsi_surat = data.deskripsi_js;
    },
    resetCheckNik() {
      this.datanik = {
        valid: false,
        nama: 'nik tidak ditemukan',
      };
    },
    checkNik() {
      this.resetCheckNik();
      if (this.tokenscr) {
        this.loading.checknik = true;
        this.axios
          .get(
            this.api + '/api/penduduk/nik',
            {
              params: {
                nik: this.addsurat.nik_surat,
                banjar: this.userbanjar,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false && resdata.data.length > 0) {
                this.datanik.valid = true;
                this.datanik.nama = resdata.data[0].nama;
              }
            }
            this.loading.checknik = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.checknik = false;
          });
      }
    },
    getJenisSurat() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jenissurat/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listjenissurat = resdata.data;
                this.addsurat.kode_surat = resdata.data[0].kode_js;
                this.addsurat.jenis_surat = resdata.data[0].id_js;
                this.addsurat.jenis_surat_l = resdata.data[0].nama_js;
                this.addsurat.deskripsi_surat = resdata.data[0].deskripsi_js;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getSurat() {
      if (this.tokenscr) {
        this.loading.changest = true;
        this.axios
          .get(
            this.api + '/api/surat/',
            {
              params: {
                status: this.filter.status,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.changest = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.changest = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddsurat.validate()) {
        if (this.tokenscr) {
          this.loading.addsurat = true;
          // additional data
          this.addsurat.banjar = this.userbanjar;
          this.addsurat.modulklian = this.modulklian;
          // request
          this.axios
            .post(
              this.api + '/api/surat/',
              qs.stringify(
                this.addsurat,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Permohonan surat "' + this.addsurat.jenis_surat_l + '" berhasil ditambahkan!';
                  this.getSurat();
                  this.$root.$emit('app-getnotifiaction');
                  this.$refs.formaddsurat.reset();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.addsurat = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.addsurat = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
